function setupUserForm() {
    const form = document.getElementById("users-form");
    if (!form) return;

    // Asumimos los IDs generados por Rails (modelo User)
    const $isPartnerCheckbox = $('#user_is_partner');
    const $partnerSelect = $('#user_partner_id');
    const $companySelect = $('#user_company_id');
    const $roleSelect = $('#user_role_id');

    // Seleccionamos los contenedores padre para ocultar toda la columna (label incluido)
    const $partnerContainer = $partnerSelect.closest('.col-sm-4');
    const $companyContainer = $companySelect.closest('.col-sm-4');

    // Buscar automáticamente el ID del rol "Partner" en las opciones disponibles
    let partnerRoleId = null;
    $roleSelect.find('option').each(function() {
        const text = $(this).text().trim().toLowerCase();
        if (text === 'partner' || text === 'socio') {
            partnerRoleId = $(this).val();
        }
    });

    function togglePartnerFields(isInitialLoad = false) {
        const isPartner = $isPartnerCheckbox.is(':checked');

        if (isPartner) {
            // Check: Desactivar y esconder company_id
            $companySelect.prop('disabled', true).val('').trigger('change');
            $companyContainer.hide();

            // Activar y mostrar partner_id
            $partnerSelect.prop('disabled', false);
            $partnerContainer.show();

            // Seleccionar rol 'Partner' y emular 'readonly' desactivándolo
            if (partnerRoleId) {
                $roleSelect.val(partnerRoleId).trigger('change');
            }
            $roleSelect.prop('disabled', true); 
        } else {
            // Uncheck: Desactivar y esconder partner_id
            $partnerSelect.prop('disabled', true).val('').trigger('change');
            $partnerContainer.hide();

            // Activar y mostrar company_id
            $companySelect.prop('disabled', false);
            $companyContainer.show();

            // Deseleccionar rol y ponerlo activo
            if (isInitialLoad !== true) {
                $roleSelect.val('').trigger('change');
            }
            $roleSelect.prop('disabled', false);
        }
    }

    // 1. Ejecutar al cargar la vista para inicializar el estado correcto
    togglePartnerFields((true));

    // 2. Escuchar el evento de cambio del checkbox
    $isPartnerCheckbox.on('change', togglePartnerFields);

    // 3. Hack de envío: Habilitar campos bloqueados antes de enviar
    $(form).on('submit', function() {
        $roleSelect.prop('disabled', false);
    });
}

function destroyUserForm() {
    const form = document.getElementById("users-form");
    if (form) {
        // Limpiar los listeners para evitar duplicados en la caché de Turbolinks
        $('#user_is_partner').off('change');
        $(form).off('submit');
    }
}

document.addEventListener("turbolinks:load", setupUserForm);
document.addEventListener('turbolinks:before-cache', destroyUserForm);